import React from 'react'
import { useTranslation } from 'react-i18next'

import Avatar from '@/components-latest/primitives/Avatar'
import Button from '@/components-latest/primitives/Button'
import ContentBlock from '@/components-latest/primitives/ContentBlock'
import { GeoMarker } from '@/components-latest/primitives/Icons'
import Spinner from '@/components-latest/primitives/Spinner'
import Text from '@/components-latest/primitives/Text'
import ReviewStars from '@/components-latest/ui/PerformancePage/ReviewStars'
import { IStoreProfileData } from '@/ducks/account/account.types'
import { useDeviceSize } from '@/hooks/useDeviceSize/useDeviceSize'

import Styles from './StoreInfoBlock.module.scss'

type Props = {
  storeProfile?: IStoreProfileData
  isLoading?: boolean
  onEditClick?: () => void
}

const StoreInfoBlock = React.memo(
  ({
    isLoading,
    storeProfile,
    onEditClick = () => {
      return
    }
  }: Props) => {
    const { t } = useTranslation()

    const { isMobile } = useDeviceSize(640)

    return (
      <ContentBlock className={Styles.wrapper}>
        {isLoading ? (
          <div className={Styles.spinner}>
            <Spinner />
          </div>
        ) : (
          <>
            <Avatar
              image={storeProfile?.store_img_name}
              string={storeProfile?.store_name}
              size={isMobile ? 'large' : 'extraLarge'}
            />
            <div className={Styles.info}>
              <Text variant="title-1">{storeProfile?.store_name}</Text>
              <p className={Styles.address}>
                <GeoMarker />
                <Text variant="nextSubtitle">{storeProfile?.address}</Text>
              </p>
              <div className={Styles.reviews}>
                <ReviewStars rating={storeProfile?.avg_ratings || 0} />
                {storeProfile?.avg_ratings ? (
                  <Text variant="title-1" className={Styles.rating}>
                    {storeProfile?.avg_ratings?.toFixed(1)}
                    <span> / 5</span>
                  </Text>
                ) : (
                  <Text className={Styles.ratingEmpty} variant="title-3">
                    {t('account.store-info.no-rating')}
                  </Text>
                )}
              </div>
            </div>
            <Button onClick={onEditClick} variant="tertiary">
              {t('account.store-info.edit-button')}
            </Button>
          </>
        )}
      </ContentBlock>
    )
  }
)

StoreInfoBlock.displayName = 'StoreInfoBlock'
export default StoreInfoBlock
